export default "__VITE_ASSET__Brvaov8m__"